import { featureItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              <i className="ri-shield-star-line text-primary-500 mr-2"></i>
              平台特色
            </h2>
            <p className="text-foreground-500 text-sm">为什么选择吃瓜网站线路一</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {featureItems.map((item, idx) => (
              <div
                key={idx}
                className="group p-6 bg-background-100 rounded-xl hover:bg-background-200 transition-colors text-center"
              >
                <span className="inline-flex w-14 h-14 items-center justify-center bg-primary-100 text-primary-500 rounded-xl text-2xl mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className={item.icon}></i>
                </span>
                <h3 className="text-sm font-medium text-foreground-800 mb-2">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}